import {PaymentMethod} from '@mintdata-wsp/common/state/ui/storefront/PaymentMethod';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {DropdownField} from '@mintdata-wsp/wsp/ui/components/forms/DropdownField';
import {InputField} from '@mintdata-wsp/wsp/ui/components/forms/InputField';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {CreditCardEntryData} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/paymentMethod/CreditCardEntryData';
import {CreditCardEntryValidators} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/paymentMethod/CreditCardEntryValidators';
import {SettingsHeading} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsHeading';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import Amex from './images/amex';
import MasterCard from './images/mastercard';
import Visa from './images/visa';

const styles = require('./CreditCardEntryForm.less');
const cx = classnames.bind(styles);

export interface CreditCardEntryFormProps
{
    paymentMethod?:PaymentMethod;
}

@observer
export class CreditCardEntryForm extends React.Component<CreditCardEntryFormProps, any>
{
    private _onCancel()
    {
        controllers.ui.dialogs.hideDialog(Dialogs.CreditCardEntry);
    }

    private _onSubmit()
    {
        controllers.ui.dialogs.hideDialog(Dialogs.CreditCardEntry);
    }

    render()
    {
        return  <Column className={cx('creditCardEntryForm')}>

                    <Column className={cx('content')}>

                        <SettingsHeading text={'Enter Payment Details'} className={cx('formHeading')}/>

                        <Row className={cx('row1')}>
                            <InputField labelClassName={cx('labelCardNumber')}
                                        className={cx('fieldCardNumber')}
                                        label={'Card Number'}
                                        isValidFn={()=>(true)}
                            />

                            <Row className={cx('cardImages')}>
                                <Visa className={cx('cardImage')}/>
                                <MasterCard className={cx('cardImage')}/>
                                <Amex className={cx('cardImage')}/>
                            </Row>
                        </Row>

                        <Row className={cx('row2')}>

                            <DropdownField label={'Month'}
                                           placeholder={'Month'}
                                           className={cx('fieldExpirationMonth')}
                                           selectClassName={cx('selectExpirationMonth')}
                                           labelClassName={cx('labelExpirationMonth')}
                                           items={CreditCardEntryData.MONTH_ITEMS}
                            />

                            <DropdownField label={'Year'}
                                           placeholder={'Year'}
                                           className={cx('fieldExpirationMonth')}
                                           selectClassName={cx('selectExpirationYear')}
                                           labelClassName={cx('labelExpirationMonth')}
                                           items={CreditCardEntryData.YEAR_ITEMS}
                            />

                            <InputField label={'Security Code'}
                                        labelClassName={cx('labelSecurityCode')}
                                        className={cx('fieldSecurityCode')}
                                        isValidFn={CreditCardEntryValidators.isValidCVV}
                                        placeholder={`___`}
                            />
                        </Row>

                        <Row className={cx('row3')}>
                            <DropdownField label={'Country'}
                                           placeholder={'United States of America'}
                                           className={cx('fieldCountry')}
                                           selectClassName={cx('selectCountry')}
                                           labelClassName={cx('labelCountry')}
                                           items={CreditCardEntryData.COUNTRY_ITEMS}
                            />

                            <DropdownField label={'State'}
                                           placeholder={'Select State'}
                                           className={cx('fieldState')}
                                           selectClassName={cx('selectState')}
                                           labelClassName={cx('labelState')}
                                           items={CreditCardEntryData.STATE_ITEMS}
                            />

                        </Row>
                    </Column>

                    <Row className={cx('buttonsRow')}>
                        <WSPButton caption={"Cancel"} style={ButtonStyle.SimpleSecondary} onClick={this._onCancel}/>
                        <WSPButton caption={"Save"} style={ButtonStyle.Raised} onClick={this._onSubmit}/>
                    </Row>

                </Column>;
    }
}





